import React from "react";

import Badge from "antd/es/badge";
import Tag from "antd/es/tag";
import Tooltip from "antd/es/tooltip";

import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

import colors from "@app/styles/_colors.module.scss";
import anyColorToHex from "@app/util/colors/anyColorToHex";

import styles from "./StageTag.module.scss";

interface Props {
  stage?: Stage;
}

const StageTag: React.FC<Props> = ({ stage }) => {
  const stageColor = stage?.color ? anyColorToHex(stage.color) : colors.slate;

  if (!stage) {
    return null;
  }

  return (
    <Tooltip
      placement="top"
      title={stage.funnel?.name}
      trigger={stage.funnel?.name ? ["hover"] : []}
    >
      <Tag className={styles.tag}>
        <Badge color={stageColor} />
        <span className={styles.name}>{stage.name}</span>
      </Tag>
    </Tooltip>
  );
};

export default StageTag;
